import LocalizedStrings from "react-localization";

export const strings = new LocalizedStrings({
  en: {
    title: "Subscriptions",
    subtitle: "overview",
    filter_org: "Filter by Organisation",
    select_org: "Select Organisation...",
    filter_plan: "Filter by Plan",
    select_plan: "Select Plan...",
    filter_status: "Filter by Status",
    select_status: "Select Status...",
    rut_number: "RUT Number",
    org_code: "Organisation Code",
    org_name: "Organisation Name",
    plan: "Plan",
    start_date: "Start Date",
    end_date: "End Date",
    status: "Status",
    active: "Active",
    expired: "Expired",
    previous: "Previous",
    next: "Next",
    payment_mode: "Payment Mode",
    amount: "Amount",
    view_details: "View",
    payment_method: "Payment Method",
    payment_id: "Payment ID",
    action: "Action",
    plan_history: "Plan History"

  },
  es: {
    title: "Suscripciones",
    subtitle: "descripción general",
    filter_org: "Filtrar por Organización",
    select_org: "Seleccionar Organización...",
    filter_plan: "Filtrar por Plan",
    select_plan: "Seleccionar Plan...",
    filter_status: "Filtrar por Estado",
    select_status: "Seleccionar Estado...",
    rut_number: "Número RUT",
    org_code: "Código de Organización",
    org_name: "Nombre de la Organización",
    plan: "Plan",
    start_date: "Fecha de Inicio",
    end_date: "Fecha de Término",
    status: "Estado",
    active: "Activo",
    expired: "Expirado",
    previous: "Anterior",
    next: "Siguiente",
    payment_mode: "Método de Pago",
    amount: "Monto",
    view_details: "Ver",
    payment_method: "Método de Pago",
    payment_id: "ID de Pago",
    action: "Action ES",
    plan_history: "Historial de Plan"
  }
});
